import { sendTestEmail } from "../../api/endpoints";
import { createMutation } from "./apiHooks";

export const useSendTestEmail = createMutation(sendTestEmail, {
  mutationKey: ["Mail", "Send"],
});
